import React, { useEffect, useState } from 'react';
import { Box, Grid,  Alert, Button, Tabs, Tab, Typography } from '@mui/material';
import { TrainingList } from './Index';
import dummyDataList from './TraininglistDummyData.json';
import { StencilList } from "react-placemoulder";
import { team_training, ongoing_training } from '../../../redux/actions/training.action';
import { useDispatch, useSelector } from 'react-redux';
import { CustomizedSnackbar } from '../../../shared/index';
import { useNavigate } from 'react-router';
import TeamTrainingHierarchy from './TeamTrainingHierarchy';
import PropTypes from 'prop-types';
import './Training.css'


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TeamTraining() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [trainingList, setTrainingList] = useState(dummyDataList);
  const [onGoingList, setOnGoingList] = useState(dummyDataList)
  const [loading, setLoading] = useState(true);
  const [onGoingLoading, setOnGoingLoading] = useState(true);
  const [value, setValue] = React.useState(0);

  let trainingListReducer = useSelector(state => state.fetchTeamTraining_Reducer.teamTrainingList)
  let ongoingTrainingReducer = useSelector(state => state.fetchOngoingTraining_Reducer.ongoingTrainings)

  useEffect(() => {
    dispatch(team_training())
    dispatch(ongoing_training())
  }, [dispatch])

  useEffect(() => {
    setLoading(false)
    setTrainingList(trainingListReducer)
  }, [trainingListReducer])

  useEffect(() => {
    setOnGoingLoading(false)
    setOnGoingList(ongoingTrainingReducer)
  }, [ongoingTrainingReducer])

  const handlepage = () => {
    navigate("/trainings/team/externaltrainings")
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
    
  };

  return (
    <div>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: "15px", borderColor: "#113776" }}>
        <Tabs  className='training-tab' value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab  className='one-tab'label="Training Request" {...a11yProps(0)} />
          <Tab className='sec-tab' label="Team Training List" {...a11yProps(1)} />
        </Tabs>

      </Box>
      <TabPanel value={value} index={0}>
        <div>
        <Button variant="contained" className="theme-btn m-top team-ext-training" onClick={() => handlepage()}>Team's External Training</Button>
              <div className="team-request">
            <h1 className="main-heading">Team member's training request list</h1>

            <Box className='training-users'>
              {loading ?
                <StencilList
                  length={5}
                  Component={TrainingList}
                  data={trainingList}
                /> :
                trainingList && trainingList.length > 0 ?
                  trainingList.map((trainingList) => {
                    return <TrainingList {...trainingList} key={trainingList.id} from="teamtraining" />
                  }) :
                  <Alert severity="error">No trainings found for your team members</Alert>
              }
            </Box>
          </div>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>   
      
      <TeamTrainingHierarchy/>    
      </TabPanel>
    </Box>

      {/* <Grid container spacing={1}>
        <Grid item xs={12}>
          <h1 className="main-heading">Team Training List</h1>
          <Button variant="contained" className="theme-btn m-top" onClick={() => handlepage()}>Team's External Training</Button>
        </Grid>
        <Grid item xs={8}>
          <div className="ongoing-team">
            <TeamTrainingHierarchy/>
            <h1 className="main-heading">ongoing training</h1>
            <Box className='training-users'>
              {onGoingLoading ?
                <StencilList
                  length={5}
                  Component={TrainingList}
                  data={onGoingList}
                /> :
                onGoingList && onGoingList.length > 0 ?
                  onGoingList.map((onGoingList) => {
                    return <TrainingList {...onGoingList} key={onGoingList.id} from="teamtraining" work="view" />
                  }) :
                  <Alert severity="error">No trainings found for your team members</Alert>
              }
            </Box>
          </div>
        </Grid>
        <Grid item xs={4}>
          
        </Grid>
      </Grid> */}
      <CustomizedSnackbar />

    </div>
  )
}
export default TeamTraining;